export default __webpack_public_path__ + "./assets/product-card-model1__035d54122dbd320d151765b89eb160ce.png";